let translationsANYIT = {
	forSell: 'Eladó',
	forRent: 'Kiadó',
	flat: 'Lakás',
	house: 'Ház',
	flatPlusHouse: 'Lakás + Ház',
	garage: 'Garázs',
	parcel: 'Telek',
	projectEstate: 'Projektingatlan',
	office: 'Iroda',
	shop: 'Üzlethelyiség',
	tourism: 'Vendéglátás',
	industrial: 'Ipari',
	agricultural: 'Mezőgazdasági',
	parcelForInnovation: 'Fejlesztési telek',
	publicInstitution: 'Közintézmények ingatlanjai',
	estatePlacePlaceholder: 'Írjon be további címeket!',
	estateTypePlaceholder: 'Lakás',
	search: 'Keresés',
	officeSearchPlaceholder: 'Írjon be egy címet vagy egy nevet!',
	officeSearchTitle: 'Iroda- és tanácsadó-kereső',
	agents: 'Ingatlanügynökök',
	offices: 'Ingatlanirodák',
	share: 'Megosztás',
	filter: 'Szűrés',
	location: 'Elhelyezkedés',
	price: 'Ár',
	shareSubject: 'Megosztás',
	en: 'Angol',
	hu: 'Magyar',
	placeSearchTooltip: 'Maximum 6 hely adható meg: település, városrész, kerület, vagy referenciaszám'
};

export default translationsANYIT;
